import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { L10nTranslationModule } from 'angular-l10n';
import { InfoService } from '../../wonder-core-ng/info-store/info.service';
import { IInfoMessage } from '../../wonder-core-ng/info-store/interfaces/info-message.interface';
import { id } from '../../wonder-core-ng/interfaces/id.type';

@Component({
  selector: 'wbi-info-message',
  templateUrl: './info-message.component.html',
  styleUrls: ['./info-message.component.scss'],
  imports: [CommonModule, L10nTranslationModule, MatButtonModule, MatIconModule],
})
export class InfoMessageComponent {
  infoService = inject(InfoService);

  @Input() floating = false;

  public readonly severityIcons = {
    info: 'info',
    success: 'check',
    warn: 'priority_high',
    error: 'dangerous',
    alert: 'dangerous',
  };

  close(id?: id): void {
    if (id) {
      this.infoService.closeMessage(id);
    }
    this.infoService.clear();
  }

  showMessages(message: IInfoMessage): { message: string; params?: Record<string, string> }[] {
    const err = message.error as {
      error: { message: string[] | string; details?: Record<string, string> };
    };
    if (err?.error?.message) {
      if (typeof (err.error.message as string[])?.splice === 'function') {
        return (err.error.message as string[]).map((message) => ({
          message,
          params: err.error.details,
        }));
      } else if (err.error.message !== 'Internal server error') {
        return [{ message: err.error.message as string, params: err.error.details }];
      }
    }

    return [{ message: message.message, params: message.parameters }];
  }
}
